import { Periodicity } from '@ecosystem/newron-core/types';
import { PeriodAggregation, TimeFrame } from '../types';

export const isCustomWeekly = (currentValue: TimeFrame) =>
  !!currentValue &&
  currentValue.aggregation === PeriodAggregation.Custom &&
  currentValue.periodicity === Periodicity.Weekly;

export const isCustomMonthly = (currentValue: TimeFrame) =>
  !!currentValue &&
  currentValue.aggregation === PeriodAggregation.Custom &&
  currentValue.periodicity === Periodicity.Monthly;
